
export const NotFound = () => {
  return <div className="p-6 text-2xl font-bold text-contrast2">404 - Pagina non trovata</div>;
};

export default NotFound;
